import api from '../http/index';
import TokenService from "./token-service";

const login = (email, password) =>{
    
  return api
  .post("login", {
    email,
    password
  })
  .then(response => {
    if (response.data.accessToken) {
      TokenService.setUser(response.data);
    }

    return response.data;
  });
  }
  const loginGoogle = (googleData) =>{
    
    return api.post("login/google", {
      token: googleData.tokenId
    })
    .then(response => {
      if (response.data.accessToken) {
        TokenService.setUser(response.data);
      }

      return response.data;
    });
    }


  const logout = () =>{
    localStorage.removeItem("user");
  }

  const register = (email, password) => {
    return api.post("registration", {
      email,
      password,
    }).then(response => {
    if (response.data.accessToken) {
      TokenService.setUser(response.data);
    }

    return response.data;
  });
  }
  const recovery = (email=null,password=null,token=null) => {
    return api.post("recovery", {
      email,
      password,
      token,
    });
  }

  const activate = (token) => {
    return api.post("activate/"+token);
  }
  const AuthService = {
    register,
    login,
    logout,
    recovery,
    loginGoogle,
    activate,

    
  };

export default AuthService;